module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Tabela de Inscritos")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover table-condensed table-responsive"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.lista), function(participante) {
    return _c('tr', {
      key: participante.id
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(participante.dorsal))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(participante.nome))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(participante.equipa))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(participante.tamanho))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(participante.acompanhantes))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(participante.valor))]), _vm._v(" "), (!participante.confirmacao && !participante.anulado) ? _c('td', {
      staticClass: "text-center warning"
    }, [_vm._v("Pendente")]) : _vm._e(), _vm._v(" "), (participante.confirmacao && !participante.checkin) ? _c('td', {
      staticClass: "text-center success"
    }, [_vm._v("Validado")]) : _vm._e(), _vm._v(" "), (participante.checkin) ? _c('td', {
      staticClass: "text-center primary"
    }, [_vm._v("Entregue")]) : _vm._e(), _vm._v(" "), (participante.anulado) ? _c('td', {
      staticClass: "text-center danger"
    }, [_vm._v("Anulado")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('div', {
      staticClass: "btn-group btn-group-xs",
      attrs: {
        "role": "group"
      }
    }, [(!participante.confirmacao && !participante.anulado) ? _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          this.valida(participante)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-ok",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (!participante.confirmacao && !participante.anulado) ? _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          this.reenvia(participante)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-share-alt",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (participante.confirmacao) ? _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          this.checkin(participante)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-flag",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (participante.confirmacao && !participante.anulado) ? _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          this.anula(participante)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (!participante.confirmacao && !participante.anulado) ? _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          this.apaga(participante)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-remove",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()])])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Dorsal")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Equipa")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("TS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Ac")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Opções")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f270c10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TabelaInscritos.vue
// module id = 252
// module chunks = 1